import { strings } from './localization';
// common rtl languages
export var rtlLanguageCodes = [
    'ar',
    'arc',
    'fa',
    'he',
    'yi',
    'ur', // Urdu
];
export function isLanguageRtl(languageCode) {
    var code = languageCode !== null && languageCode !== void 0 ? languageCode : strings.getLanguage();
    return rtlLanguageCodes.includes(code);
}
